(() => {
  if (window.pageEditorialHeroInitialized) return;
  window.pageEditorialHeroInitialized = true;

  const heroSelector = 'page-editorial-hero[data-heading-enabled="true"]';
  const heroHeadingSelector = '[data-page-editorial-hero-heading]';
  const contentHeadingSelector = '[data-page-primary-heading]';

  const replaceHeadingTag = (heading, tagName) => {
    if (!heading || heading.tagName.toLowerCase() === tagName) return heading;

    const replacement = document.createElement(tagName);
    [...heading.attributes].forEach(({ name, value }) => replacement.setAttribute(name, value));
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);
    return replacement;
  };

  const updatePageHeadings = () => {
    const root = document.getElementById('MainContent') || document;
    const heroHeadings = [...root.querySelectorAll(heroSelector)]
      .map((hero) => hero.querySelector(heroHeadingSelector))
      .filter(Boolean);
    const primaryHeroHeading = heroHeadings[0];

    heroHeadings.forEach((heading) => {
      replaceHeadingTag(heading, heading === primaryHeroHeading ? 'h1' : 'h2');
    });

    root.querySelectorAll(contentHeadingSelector).forEach((heading) => {
      replaceHeadingTag(heading, primaryHeroHeading ? 'h2' : 'h1');
    });
  };

  customElements.define('page-editorial-hero', class PageEditorialHero extends HTMLElement {
    connectedCallback() {
      queueMicrotask(updatePageHeadings);
    }

    disconnectedCallback() {
      queueMicrotask(updatePageHeadings);
    }
  });

  document.addEventListener('shopify:section:load', updatePageHeadings);
  document.addEventListener('shopify:section:reorder', updatePageHeadings);
  document.addEventListener('shopify:section:unload', () => queueMicrotask(updatePageHeadings));
})();
